var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"options"},_vm._l((_vm.managementOptions),function(option,index){return _c('landing-page-card',{key:index,staticClass:"options-card",attrs:{"heading":option.heading,"description":option.description,"buttonText":option.buttonText,"buttonLink":option.buttonLink,"image":option.image,"label":option.label}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }